import { Component, OnInit } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  year: string;

  constructor() { }

  ngOnInit(): void {
    this.year = _.toString((new Date()).getFullYear());
  }

}
